<template>
  <div class="AppFooter">
    <v-footer app>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </div>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>